import {getBrowserName} from "./BrowserService";

/**
 * Generate a temporary path for the file.
 *
 * @param file
 * @returns {any}
 */
export const generateTempPath = (file) => {
    // If IE then create as image object, else use HTML element
    return getBrowserName === 'Internet Explorer' ? new Image() : URL.createObjectURL(file);
};


// WEBPACK FOOTER //
// ./src/services/DocumentService.js